// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.csv {\n    font-weight: bold;\n    font-size: 1.2em;\n}\n", "",{"version":3,"sources":["webpack://./resources/js/modules/PanelistImporter/components/FileInspector.vue"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":["\n.csv {\n    font-weight: bold;\n    font-size: 1.2em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
